import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListPlaceTips.css';
import {
    Col
} from 'react-bootstrap';

//Images
import BgImage from '../../../images/banner/939b39d1472ce0b492d8cce42ff66f5c.png';

class ListPlaceTips extends React.Component {
    static propTypes = {};

    render() {

        return (
            <Col xs={12} sm={6} md={6} lg={6}>
                <div>
                    <img src={BgImage} className={s.listPlaceImage} />
                </div>
            </Col>
        );
    }
}

const mapState = (state) => ({
    sideMenuData: state.sideMenu.data
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ListPlaceTips)));


// WEBPACK FOOTER //
// src/components/ListPlaceTips/ListPlaceImage.js